import React, { useEffect, useRef } from "react";

const UseTransportViz = () => {
  const vizRef = useRef(null);

  useEffect(() => {
    const vizElement = vizRef.current.getElementsByTagName("object")[0];
    vizElement.style.width = "120%";
    vizElement.style.height = "70vh";

    const scriptElement = document.createElement("script");
    scriptElement.src = "https://public.tableau.com/javascripts/api/viz_v1.js";
    vizElement.parentNode.insertBefore(scriptElement, vizElement);

    return () => {
      scriptElement.remove();
    };
  }, []);

  return (
    <div>
      <div
        ref={vizRef}
        className="tableauPlaceholder"
        id="viz1726378564288"
        style={{ position: "relative" }}
      >
        <noscript>
          <a href="#">
            <img
              alt="Trends in Public Transport Safety Perception: Feeling Safe and Unsafe While Using Public Transport (2005-2021)"
              src="https://public.tableau.com/static/images/Bo/Book1_17263657633860/Safe_Unsafe/1_rss.png"
              style={{ border: "none" }}
            />
          </a>
        </noscript>
        <object className="tableauViz" style={{ display: "none" }}>
          <param name="host_url" value="https%3A%2F%2Fpublic.tableau.com%2F" />
          <param name="embed_code_version" value="3" />
          <param name="site_root" value="" />
          <param name="name" value="Book1_17263657633860/Safe_Unsafe" />
          <param name="tabs" value="no" />
          <param name="toolbar" value="yes" />
          <param
            name="static_image"
            value="https://public.tableau.com/static/images/Bo/Book1_17263657633860/Safe_Unsafe/1.png"
          />
          <param name="animate_transition" value="yes" />
          <param name="display_static_image" value="yes" />
          <param name="display_spinner" value="yes" />
          <param name="display_overlay" value="yes" />
          <param name="display_count" value="yes" />
          <param name="language" value="en-US" />
          <param name="filter" value="publish=yes" />
        </object>
      </div>
      <div className="viz-description">
        <p>
          This chart shows trends in public transport safety perception from
          2005 to 2021 while using public transport. It highlights that both men
          and women feel safer over time, but women consistently report feeling
          less safe. Men's safety perception increased from 8410 to 9130, while
          women's rose from 6810 to 7760. The number of women feeling unsafe
          decreased from 3190 to 2230, and men's unsafe perception dropped from
          1590 to 760 by 2021.
        </p>
      </div>
    </div>
  );
};

export default UseTransportViz;
